import { Box, UnstyledButton, Text } from '@mantine/core'

interface Props {
  reactions: { emoji: string; count: number }[]
  myReaction?: string | null
  onToggle: (emoji: string) => void
}

export function ReactionPills({ reactions, myReaction, onToggle }: Props) {
  if (!reactions || reactions.length === 0) return null

  return (
    <Box
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 4,
        marginTop: 4,
      }}
    >
      {reactions.map((r) => {
        const isMine = myReaction === r.emoji
        return (
          <UnstyledButton
            key={r.emoji}
            onClick={() => onToggle(r.emoji)}
            aria-pressed={isMine}
            aria-label={`Reagir ${r.emoji} — ${r.count}`}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 4,
              padding: '2px 8px',
              borderRadius: 20,
              border: isMine
                ? '1.5px solid var(--mantine-color-teal-5)'
                : '1.5px solid var(--mantine-color-default-border)',
              background: isMine
                ? 'var(--ai-bg-subtle)'
                : 'var(--mantine-color-body)',
              cursor: 'pointer',
              transition: 'background 0.12s ease, border-color 0.12s ease',
              lineHeight: 1,
            }}
          >
            <Text span style={{ fontSize: 15, lineHeight: 1 }}>
              {r.emoji}
            </Text>
            <Text
              span
              size="xs"
              fw={isMine ? 700 : 500}
              c={isMine ? 'teal.7' : 'dimmed'}
              style={{ lineHeight: 1 }}
            >
              {r.count}
            </Text>
          </UnstyledButton>
        )
      })}
    </Box>
  )
}
